import { render, staticRenderFns } from "./oncallShiftSetting.vue?vue&type=template&id=c4bb9698&"
import script from "./oncallShiftSetting.vue?vue&type=script&lang=ts&"
export * from "./oncallShiftSetting.vue?vue&type=script&lang=ts&"
import style0 from "./oncallShiftSetting.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports